/*
 * @Descripttion:
 * @Author: Yi Yunwan
 * @Date: 2021-04-30 10:59:48
 * @LastEditors: Chen Zhi
 * @LastEditTime: 2021-11-17 16:39:29
 */

export const SECRET_KEY = 'FfZfoOEe1Q3xOefgW74rULxaHnWI6cJv'
export const reportConfig = {
  appKey: '3f1c23c436c0f6de',
  baseURL: process.env.VUE_APP_REPORTBASEURL_API,
  debug: true
}
export const baseURL = process.env.VUE_APP_BASE_API
export const apiMock =
  process.env.NODE_ENV !== 'production' && location.href.includes('mock=true')
export const mockBaseURL = process.env.VUE_APP_MOCK_BASE_API
export const actionName = 'Allo'
export const actType = 'actType'
